// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"f00819b8","498":"d794a9d0","590":"e70119a3","703":"17e7fb09","982":"725c5875"}[chunkId] + ".chunk.js";
};